import { createBrowserRouter } from 'react-router-dom';
import { Icons, TabsType } from '../enums';
import strings from '../language/Swedish';
import {
  Ads,
  Login,
  Market,
  NotFound,
  ErrorPage,
  PriceDevelopment,
  Sold,
  AutoLogin
} from '../pages';
import Dashboard from '../pages/dashboard/Dashboard';
import Projects from '../pages/projects/Projects';
import PdfReport from '../pages/report/PdfReport';
import { NavItemsType } from '../types/dataTypes';
import { PATH } from './Paths';
import ProtectedRoute from './ProtectedRoute';

const publicRoutes = [
  {
    path: PATH.login,
    element: <Login />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: `${PATH.pdf}`,
    element: <PdfReport />,
    errorElement: <ErrorPage />,
  },
  {
    path: `${PATH.autoLogin}`,
    element: <AutoLogin />,
    errorElement: <ErrorPage />,
  }
];

const privateRoutes = [
  {
    path: PATH.home,
    element: <Dashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: `${PATH.project}/:id`,
    element: <Dashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: PATH.projects,
    element: <Projects />,
    errorElement: <ErrorPage />,
  },
];

const routes = [
  ...publicRoutes,
  ...privateRoutes.map((route) => ({
    ...route,
    element: <ProtectedRoute element={route.element}></ProtectedRoute>,
  })),
];

const navItems: NavItemsType[] = [
  {
    id: TabsType.sold,
    label: strings.navigation.sold,
    url: `${PATH.sold}`,
    icon: Icons.house,
    location: <Sold />,
  },
  {
    id: TabsType.ads,
    label: strings.navigation.ads,
    url: `${PATH.ads}`,
    icon: Icons.key,
    location: <Ads />,
  },
  {
    id: TabsType.market,
    label: strings.navigation.market,
    url: `${PATH.market}`,
    icon: Icons.chartPie36,
    location: <Market />,
  },
  {
    id: TabsType.priceDevelopment,
    label: strings.navigation.priceDev,
    url: `${PATH.priceDevelopment}`,
    icon: Icons.ranking,
    location: <PriceDevelopment />,
  },
];

const router = createBrowserRouter(routes, {});

export { router, navItems };
